import _ from 'lodash';
import { createSelector } from 'reselect';
import { getEntityByName } from '../appEntities';
import { TABLE_UNMOUNT } from '../Table/tableActions';

// Action Types
export const MERCHANT_ONBOARDING_LOAD = 'LEAD_TO_LIVE/MERCHANT_ONBOARDING_LOAD';
export const MERCHANT_ONBOARDING_SUCCESS = 'LEAD_TO_LIVE/MERCHANT_ONBOARDING_SUCCESS';
export const MERCHANT_ONBOARDING_FAILURE = 'LEAD_TO_LIVE/MERCHANT_ONBOARDING_FAILURE';

const initialState = {
    merchants: [],
    loading: false,
    error: null,
    count: 0,
    pages: 0,
    hasMore: false,
    offset: 0,
    limit: 0
};

export default function reducer(state = initialState, action = {}) {
    let newState;
    switch (action.type) {
        case TABLE_UNMOUNT:
            newState = {
                ...state,
                merchants: []
            };

            return _.isEqual(state, newState) ? state : newState;

        case MERCHANT_ONBOARDING_LOAD:
            newState = {
                ...state,
                merchants: [],
                error: null,
                loading: true
            };

            return _.isEqual(state, newState) ? state : newState;

        case MERCHANT_ONBOARDING_SUCCESS:
            newState = {
                ...state,
                merchants: action.merchantOnboarding || [],
                count: action.count || 0,
                loading: false,
                error: null,
                pages: action.pages || 0,
                hasMore: action.hasMore || false,
                offset: action.offset || state.offset,
                limit: action.limit || state.limit
            };

            return _.isEqual(state, newState) ? state : newState;

        case MERCHANT_ONBOARDING_FAILURE:
            newState = {
                ...state,
                merchants: [],
                count: 0,
                error: action.error,
                loading: false,
                pages: 0
            };

            return _.isEqual(state, newState) ? state : newState;

        default:
            return state;
    }
}

export const getMerchantOnboardingEntity = createSelector(
    (state) => state,
    (state) => getEntityByName(state, 'merchantOnboarding')
);

export const getMerchantOnboarding = createSelector(
    getMerchantOnboardingEntity,
    (entity) => _.get(entity, 'merchants')
);

export const getIsMerchantOnboardingLoading = createSelector(
    getMerchantOnboardingEntity,
    (entity) => _.get(entity, 'loading')
);

export const getMerchantOnboardingError = createSelector(
    getMerchantOnboardingEntity,
    (entity) => _.get(entity, 'error')
);

export const getMerchantOnboardingErrorMessage = createSelector(
    getMerchantOnboardingError,
    (error) => _.get(error, 'message')
);

export const getMerchantPages = createSelector(
    getMerchantOnboardingEntity,
    (entity) => _.get(entity, 'pages')
);

export const getMerchantCount = createSelector(
    getMerchantOnboardingEntity,
    (entity) => _.get(entity, 'count')
);

export const getMerchantHasMore = createSelector(
    getMerchantOnboardingEntity,
    (entity) => _.get(entity, 'hasMore')
);

